export const convertBytes = (bytes: number) => {
  const kb = Math.floor(bytes / 1024);
  const mb = Math.floor(kb / 1024);
  if (mb > 0) {
    return `${mb} MB`;
  } else {
    return `${kb} KB`;
  }
};
